import { LanguageTranslationCommandModel } from './language-translation-command.model';

export class LanguageTranslationSetCommandModel {
    public languageTranslationSetId: string;
    public languageTranslationName: string;
    public statusCode: string;
    public languageTranslations: LanguageTranslationCommandModel[];
}